import { render, staticRenderFns } from "./Amenity.vue?vue&type=template&id=4e23f460"
import script from "./Amenity.vue?vue&type=script&lang=js"
export * from "./Amenity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports